class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.sizeOfThumb = 22; // in pixels
    this.currency = this.getAttribute('data-currency');
    this.minSlider = this.querySelector('.min-slider-input');
    this.maxSlider = this.querySelector('.max-slider-input');
    this.minSliderLabel = this.querySelector('.min-slider-label');
    this.maxSliderLabel = this.querySelector('.max-slider-label');
    this.minSubmit = document.getElementById('minSubmit'); // @todo - pass data in event instead
    this.maxSubmit = document.getElementById('maxSubmit'); // @todo - pass data in event instead
    this.selectedTrack = this.querySelector('.price-range-selected-track');
    this.rangeLabel = this.querySelector('.range-label');
    this.priceFormat = this.currency + '\{\{amount_no_decimals\}\}';
    // this.addEventListener('resize', this.onResize.bind(this));
    this.resizeObserver = new ResizeObserver(this.onResize.bind(this));
    this.resizeObserver.observe(this);
    this.sliders = [this.minSlider, this.maxSlider];
    this.sliders.forEach(slider => {
      slider.addEventListener('input', this.updateUI.bind(this));
    });
  }

  init() {

    this.calcIncrement();
    this.updateUI();
  }

  connectedCallback() {
    this.init()
  }

  onResize() {
    this.calcIncrement();
    this.updateUI();
  }

  calcIncrement() {
    this.increment = (this.clientWidth - this.sizeOfThumb) / this.getAttribute('data-max-limit');
  }

  updateUI() {
    const minSliderVal = this.minSlider.value;
    const maxSliderVal = this.maxSlider.value;
    const minValue = Math.min(minSliderVal, maxSliderVal);
    const maxValue = Math.max(minSliderVal, maxSliderVal);
    const minSliderLeft = (minSliderVal * this.increment);
    const maxSliderLeft = (maxSliderVal * this.increment);
    const minSliderPrice = this.formatPrice(minSliderVal);
    const maxSliderPrice = this.formatPrice(maxSliderVal);

    this.minSliderLabel.innerText = minSliderPrice;
    this.minSliderLabel.style.left = (minSliderLeft + (this.sizeOfThumb / 2)) + "px";
    this.maxSliderLabel.innerText = maxSliderPrice;
    this.maxSliderLabel.style.left = (maxSliderLeft + (this.sizeOfThumb / 2)) + "px"; // 5 is half of the width of the thumb

    const fromLeft = Math.min(minSliderLeft, maxSliderLeft); // center of thumb
    const toLeft = Math.max(minSliderLeft, maxSliderLeft); // center of thumb
    const width = toLeft - fromLeft - this.sizeOfThumb;
    const minPrice = this.formatPrice(minValue);
    const maxPrice = this.formatPrice(maxValue);

    this.minSubmit.value = minValue;
    this.maxSubmit.value = maxValue;
    this.selectedTrack.style.left = (fromLeft + (this.sizeOfThumb)) + "px";
    this.selectedTrack.style.width  = width + "px";
    this.rangeLabel.innerText = `${minPrice} - ${maxPrice}`;
  }

  hasMinPrice() {

  }

  hasMaxPrice() {

  }

  getMinPrice() {

  }

  getMaxPrice() {

  }

  formatPrice(dollars) {
    return window.Shopify.formatMoney(dollars * 100, this.priceFormat);
  }
}

customElements.define('price-range', PriceRange);
